import { Injectable } from '@angular/core';
import { APIService } from 'src/app/api';
import {
  Project,
  ProjectLocalization,
  ProjectStatus,
  ProjectCountry,
  UserProjectProgress } from 'KiaLearn.Common/angular-common-libraries/projects/web-api-client/src/lib/generated/kia-projects-api-client';


@Injectable({
  providedIn: 'root',
})
export class ProjectsService {
  constructor(private apiService: APIService) {
  }

  getPublishedProjects(): Promise<Project[]> {
    return this.apiService.getKiaProjectsClient()?.getProjects(false, ProjectStatus.Published, undefined);
  }

  getProject(projectId: string, countryId: string | undefined = undefined): Promise<Project> {
    return this.apiService.getKiaProjectsClient()?.getProjectsId(countryId, projectId);
  }

  getProjectsTraineeProgress(): Promise<UserProjectProgress[]> {
    return this.apiService.getKiaProjectsClient()?.getProjectsTraineeProgress();
  }

  getProjectsAllLocalizations(): Promise<ProjectLocalization[]> {
    return this.apiService.getKiaProjectsClient()?.getProjectsAllLocalizations();
  }

  getLocalizationByProjectAndCountry(projectId: string, countryId: string): Promise<ProjectLocalization> {
    return this.apiService.getKiaProjectsClient()?.getProjectsProjectIdLocalizationsCountryId(projectId, countryId);
  }

  getProjectsAllAvailabilityCountries(): Promise<ProjectCountry[]> {
    return this.apiService.getKiaProjectsClient()?.getProjectsAllAvailabilityCountries();
  }

  getDashboardOverview() {
    return this.apiService.getKiaProjectsClient()?.getDashboardOverview(true);
  }

  getPublishedProjectsForFilter() {
    return this.apiService.getKiaProjectsClient()?.getProjectsFilter(true, true);
  }

  getProjectIdByAccessKey(accessKey: string) {
    return this.apiService.getKiaProjectsClient()?.getProjectIdByAccessKey(accessKey);
  }
}
